import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
import { PageHeaderPopover } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap/PageHeaderPopover';

// Lib
import {
    SCHEDULER_COLLABORATION_NOTIFICATIONS,
    SCHEDULER_COLLABORATION_SETTINGS
} from '@/routes/privateRoutes';

type CollaborationWrapperProps = {
    children: React.ReactNode;
};

const CollaborationContentWrapper = ({ children }: CollaborationWrapperProps) => {
    const { t } = useTranslation();

    const dropdownLinks = [
        {
            href: SCHEDULER_COLLABORATION_NOTIFICATIONS,
            label: t('scheduler:collaboration.tabs.notifications')
        },
        {
            href: SCHEDULER_COLLABORATION_SETTINGS,
            label: t('scheduler:collaboration.tabs.settings')
        }
    ];

    return (
        <>
            <PageHeaderPopover dropdownLinks={dropdownLinks} />
            {children}
        </>
    );
};

const CollaborationWrapper = ({ children }: CollaborationWrapperProps) => {
    return (
        <WrapperSwitchLayout>
            <CollaborationContentWrapper>{children}</CollaborationContentWrapper>
        </WrapperSwitchLayout>
    );
};

export default CollaborationWrapper;
